import { Set } from "immutable";
import { ColumnGroup, Column } from "ag-grid-community";
import { IAllocationDimensionValue } from "helpers/allocation-dimension";
import { IPreference } from "components/product-collection/product-collection-views/product-collection-grid-view/tool-panels/data-view-panel/grid-param-helpers";
import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";

export const columnTreeAsDisplayPreferences = (currentTree: ColumnGroup[], mainGroups: IAllocationDimensionValue[]) => {
    const primaryColumns = mainGroups.reduce((acc, allocation) => {
        return acc.add(allocation.id);
    }, Set<string>());

    function colGroupToDisplayProperty(colGroup: ColumnGroup | Column): IPreference {
        let children;

        if ((colGroup as ColumnGroup).getChildren) {
            const nestedChildren = (colGroup as ColumnGroup).getChildren();
            if (nestedChildren.length === 1 && nestedChildren[0] instanceof Column) {
                return colGroupToDisplayProperty(nestedChildren[0] as Column);
            }

            children = nestedChildren.reduce((acc, col) => {
                acc.push(colGroupToDisplayProperty(col as Column | ColumnGroup));
                return acc;
            }, []);
        }

        return {
            field_name: (colGroup as ColumnGroup).getGroupId?.() || (colGroup as Column).getId(),
            display: { hidden: false },
            grid_column: {
                width: colGroup.getActualWidth(),
                expand: (colGroup as ColumnGroup).getDisplayedChildren
                    ? (colGroup as ColumnGroup).getDisplayedChildren().length !== 1
                    : true,
            },
            children,
        };
    }

    return currentTree.reduce((acc, column) => {
        column.getGroupId && primaryColumns.has(column.getGroupId()) && acc.push(colGroupToDisplayProperty(column));
        return acc;
    }, []);
};

export const doorsOnlyLayout = (currentTree: Column[]) => {
    return currentTree.reduce((acc, curr) => {
        if (curr.getId().includes(ColumnTypes.DoorBulkQuantity)) {
            acc.push({
                field_name: curr.getId(),
                display: { hidden: false },
                grid_column: {
                    width: curr.getActualWidth(),
                    expand: true,
                },
            });
        }
        return acc;
    }, []);
};
